<script>

export default {
  name: 'FinanceModule'
}
</script>

<template>
  <div>
    <RouterView />
  </div>
</template>
